/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/resources/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 840);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(55);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PreferredUnivManager = function () {
    function PreferredUnivManager() {
        _classCallCheck(this, PreferredUnivManager);
    }

    _createClass(PreferredUnivManager, [{
        key: 'send',
        value: function send() {
            var _this = this;

            /* Cookie */
            var univList = dn.segments.schoolChoices.find();
            if (!univList) return;

            dn.db.searchOffers({ id: univList }).then(function (ans) {

                var list = [];

                // 並び替え
                univList.forEach(function (univ) {
                    var target = ans.hits.find(function (hit) {
                        return hit.id === univ;
                    });

                    if (target) {
                        list.push({
                            bosyutaniCd: target.id,
                            univNm: target.university_name,
                            gakubuNm: target.faculty_name,
                            gakkaNm: target.department_name,
                            nitteiNm: target.schedule_name,
                            hoshikiNm: target.examination_method_name
                        });
                    }
                });

                _this.onFetch(list);
            }).catch(function (error) {});
        }
    }, {
        key: 'onFetch',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(list) {
                var seisekiApiConfig, productionUrl, newRefUrl, dbStates, targetExamId, targetRegDate, request;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                seisekiApiConfig = dn.$store.getters['config/seisekiApi'];
                                /* 呼び出し先URL（生徒機能からの呼び出し） */
                                // 本番環境

                                productionUrl = seisekiApiConfig.domain.manabi + 'cmp/services/public/stdtShibokoInfo';
                                // ios11対応

                                newRefUrl = seisekiApiConfig.domain.dn;

                                if (list) {
                                    _context.next = 5;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 5:
                                dbStates = dn.$store.getters['ls/at']('db_states', {});

                                if (dbStates) {
                                    _context.next = 8;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 8:
                                targetExamId = seisekiApiConfig.examId.dn.replace("{GAKUNEN}", "K3");
                                _context.next = 11;
                                return this.getRegDate(targetExamId);

                            case 11:
                                targetRegDate = _context.sent;
                                request = {
                                    serviceId: 2,
                                    examId: targetExamId,
                                    stdt: {
                                        seiseki: {
                                            details: {
                                                shiboList: {
                                                    cmpsSiboList: list
                                                }
                                            }
                                        }
                                    },
                                    regDate: targetRegDate
                                };


                                window.fetch(productionUrl, {
                                    credentials: 'include',
                                    method: 'PUT',
                                    mode: 'cors',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify(request),
                                    referrer: newRefUrl,
                                    referrerPolicy: 'no-referrer-when-downgrade'
                                }).then(function (ret) {
                                    //
                                }).catch(function (error) {
                                    dn.$alert('エラーが発生したため志望校をDB連携できませんでした。');
                                });

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function onFetch(_x) {
                return _ref.apply(this, arguments);
            }

            return onFetch;
        }()
    }, {
        key: 'getRegDate',
        value: function getRegDate(examId) {
            /*
            let request = {
                serviceId: 2,
                examId : examId
            };
             return fetch(testUrl, {
                credentials : 'include',
                method : 'POST',
                mode : 'cors',
                headers : {
                    'Accept' : 'application/json',
                    'Content-Type': 'application/json'
                },
                body : JSON.stringify(request),
                referrer : refUrl,
                referrerPolicy : 'no-referrer-when-downgrade'
            }).then( ans => {
                return ans.json();
            }).then( ret => {
                return ret.regDate;
            }).catch(error => {
                
            });
            */

            var currentDate = new Date();
            var regDate = currentDate.getFullYear() + ("0" + (currentDate.getMonth() + 1)).slice(-2) + ("0" + currentDate.getDate()).slice(-2) + ("0" + currentDate.getHours()).slice(-2) + ("0" + currentDate.getMinutes()).slice(-2) + ("0" + currentDate.getSeconds()).slice(-2) + ("00" + currentDate.getMilliseconds()).slice(-3);

            return regDate;
        }
    }]);

    return PreferredUnivManager;
}();

exports.default = PreferredUnivManager;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(8)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob:
    'FileReader' in self &&
    'Blob' in self &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':')
    var key = parts.shift().trim()
    if (key) {
      var value = parts.join(':').trim()
      headers.append(key, value)
    }
  })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : 'OK'
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = self.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      resolve(new Response(body, options))
    }

    xhr.onerror = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.ontimeout = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.onabort = function() {
      reject(new DOMException('Aborted', 'AbortError'))
    }

    xhr.open(request.method, request.url, true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob'
    }

    request.headers.forEach(function(value, name) {
      xhr.setRequestHeader(name, value)
    })

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!self.fetch) {
  self.fetch = fetch
  self.Headers = Headers
  self.Request = Request
  self.Response = Response
}


/***/ }),

/***/ 8:
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),

/***/ 840:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _App = __webpack_require__(841);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.component(_App2.default.name, _App2.default);

// dn.one('mount', () => {
//   new Vue({
//     components: {
//       [App.name]: App,
//     },
//     el: '#pg-app',
//     parent: dn,
//   });
// });

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(842)
  __webpack_require__(844)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(846),
  /* template */
  __webpack_require__(847),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b2de2106",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(843);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("13cfcc24", content, true, {});

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, "#pg-app{margin-bottom:30px}#pg-app .pg-uni-bnr{color:#0aa0d7;line-height:90px;text-align:center;margin-bottom:20px;font-weight:700}#pg-app .pg-linkto-search{margin-bottom:20px}@media (min-width:710px){#pg-app .pg-linkto-search{width:200px}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/bible/myuniv/App.vue"],"names":[],"mappings":"AACA,QAAQ,kBAAkB,CACzB,AACD,oBAAoB,cAAc,iBAAiB,kBAAkB,mBAAmB,eAAe,CACtG,AACD,0BAA0B,kBAAkB,CAC3C,AACD,yBACA,0BAA0B,WAAW,CACpC,CACA","file":"App.vue","sourcesContent":["\n#pg-app{margin-bottom:30px\n}\n#pg-app .pg-uni-bnr{color:#0aa0d7;line-height:90px;text-align:center;margin-bottom:20px;font-weight:700\n}\n#pg-app .pg-linkto-search{margin-bottom:20px\n}\n@media (min-width:710px){\n#pg-app .pg-linkto-search{width:200px\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(845);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("048eb8bc", content, true, {});

/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my-offer[data-v-b2de2106]{background:#fff;border:1px solid #adc4cc;position:relative;z-index:1;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-backface-visibility:hidden;backface-visibility:hidden}.my-offer+.my-offer[data-v-b2de2106]:not(.my-offer--moving){border-top:0}.my-offer__header[data-v-b2de2106]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:stretch;-webkit-align-items:stretch;-ms-flex-align:stretch;align-items:stretch}.my-offer__header-body[data-v-b2de2106]{padding:10px 10px 10px 20px;margin-right:auto}.my-offer__header-rank[data-v-b2de2106]{font-size:16px;font-weight:700;padding-top:5px;padding-bottom:5px}.my-offer__header-action[data-v-b2de2106]{-webkit-user-drag:none;-khtml-user-drag:none;-ms-user-drag:none;user-drag:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;position:relative;border:0;display:-webkit-box;display:-webkit-flex;display:flex;vertical-align:middle;box-sizing:border-box;cursor:pointer;text-decoration:none;background:transparent;padding:0;width:44px;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;border-left:1px solid #adc4cc;-webkit-transition:background-color .25s;transition:background-color .25s;display:-ms-flexbox}.my-offer__header-action[data-v-b2de2106],.my-offer__header-action[data-v-b2de2106]:active,.my-offer__header-action[data-v-b2de2106]:focus,.my-offer__header-action[data-v-b2de2106]:hover{text-decoration:none}.my-offer__header-action.is-disabled[data-v-b2de2106]{cursor:default;pointer-events:none}.my-offer__header-action[data-v-b2de2106]:not(.is-disabled):focus,.my-offer__header-action[data-v-b2de2106]:not(.is-disabled):hover{background:#fafafa}.my-offer__header-action[data-v-b2de2106]:not(.is-disabled):active{background:#efefef}.my-offer__body[data-v-b2de2106]{padding:20px;border-top:1px solid #adc4cc}.my-offer__university-name[data-v-b2de2106]{font-size:16px;color:#000;font-weight:700;margin:0 0 10px}.my-offer__meta[data-v-b2de2106]{display:inline-block}.my-offer__meta-list[data-v-b2de2106]{border-bottom:2px solid #0aa0d7;padding-bottom:8px}.my-offer__meta[data-v-b2de2106]:not(:first-child){margin-left:1em}.my-offer__links[data-v-b2de2106]{letter-spacing:4em}.my-offer__link[data-v-b2de2106]{display:inline-block;vertical-align:middle;margin-top:10px;letter-spacing:normal}.my-offer__missing-notice[data-v-b2de2106]{font-weight:700;color:red}.my-wrap[data-v-b2de2106]{display:inline-block}.gaibu-link[data-v-b2de2106]{text-decoration:underline}@media (max-width:709px){.my-offer__body[data-v-b2de2106],.my-offer__header-body[data-v-b2de2106]{padding-left:10px}.my-offer__body[data-v-b2de2106]{padding-right:10px}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/bible/myuniv/App.vue"],"names":[],"mappings":"AACA,2BAA2B,gBAAgB,yBAAyB,kBAAkB,UAAU,oCAAoC,4BAA4B,mCAAmC,0BAA0B,CAC5N,AACD,4DAA4D,YAAY,CACvE,AACD,mCAAmC,oBAAoB,qBAAqB,oBAAoB,aAAa,0BAA0B,4BAA4B,uBAAuB,mBAAmB,CAC5M,AACD,wCAAwC,4BAA4B,iBAAiB,CACpF,AACD,wCAAwC,eAAe,gBAAgB,gBAAgB,kBAAkB,CACxG,AACD,0CAA0C,uBAAuB,sBAAsB,mBAAmB,eAAe,yBAAyB,sBAAsB,qBAAqB,iBAAiB,2BAA2B,wCAAwC,aAAa,wBAAwB,qBAAqB,gBAAgB,kBAAkB,SAAS,oBAAoB,qBAAqB,aAAa,sBAAsB,sBAAsB,eAAe,qBAAqB,uBAAuB,UAAU,WAAW,yBAAyB,2BAA2B,sBAAsB,mBAAmB,wBAAwB,+BAA+B,qBAAqB,uBAAuB,8BAA8B,yCAAyC,iCAAiC,mBAAmB,CACl2B,AACD,2LAA2L,oBAAoB,CAC9M,AACD,sDAAsD,eAAe,mBAAmB,CACvF,AACD,oIAAoI,kBAAkB,CACrJ,AACD,mEAAmE,kBAAkB,CACpF,AACD,iCAAiC,aAAa,4BAA4B,CACzE,AACD,4CAA4C,eAAe,WAAW,gBAAgB,eAAe,CACpG,AACD,iCAAiC,oBAAoB,CACpD,AACD,sCAAsC,gCAAgC,kBAAkB,CACvF,AACD,mDAAmD,eAAe,CACjE,AACD,kCAAkC,kBAAkB,CACnD,AACD,iCAAiC,qBAAqB,sBAAsB,gBAAgB,qBAAqB,CAChH,AACD,2CAA2C,gBAAgB,SAAS,CACnE,AACD,0BAA0B,oBAAoB,CAC7C,AACD,6BAA6B,yBAAyB,CACrD,AACD,yBACA,yEAAyE,iBAAiB,CACzF,AACD,iCAAiC,kBAAkB,CAClD,CACA","file":"App.vue","sourcesContent":["\n.my-offer[data-v-b2de2106]{background:#fff;border:1px solid #adc4cc;position:relative;z-index:1;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-backface-visibility:hidden;backface-visibility:hidden\n}\n.my-offer+.my-offer[data-v-b2de2106]:not(.my-offer--moving){border-top:0\n}\n.my-offer__header[data-v-b2de2106]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:stretch;-webkit-align-items:stretch;-ms-flex-align:stretch;align-items:stretch\n}\n.my-offer__header-body[data-v-b2de2106]{padding:10px 10px 10px 20px;margin-right:auto\n}\n.my-offer__header-rank[data-v-b2de2106]{font-size:16px;font-weight:700;padding-top:5px;padding-bottom:5px\n}\n.my-offer__header-action[data-v-b2de2106]{-webkit-user-drag:none;-khtml-user-drag:none;-ms-user-drag:none;user-drag:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;position:relative;border:0;display:-webkit-box;display:-webkit-flex;display:flex;vertical-align:middle;box-sizing:border-box;cursor:pointer;text-decoration:none;background:transparent;padding:0;width:44px;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;border-left:1px solid #adc4cc;-webkit-transition:background-color .25s;transition:background-color .25s;display:-ms-flexbox\n}\n.my-offer__header-action[data-v-b2de2106],.my-offer__header-action[data-v-b2de2106]:active,.my-offer__header-action[data-v-b2de2106]:focus,.my-offer__header-action[data-v-b2de2106]:hover{text-decoration:none\n}\n.my-offer__header-action.is-disabled[data-v-b2de2106]{cursor:default;pointer-events:none\n}\n.my-offer__header-action[data-v-b2de2106]:not(.is-disabled):focus,.my-offer__header-action[data-v-b2de2106]:not(.is-disabled):hover{background:#fafafa\n}\n.my-offer__header-action[data-v-b2de2106]:not(.is-disabled):active{background:#efefef\n}\n.my-offer__body[data-v-b2de2106]{padding:20px;border-top:1px solid #adc4cc\n}\n.my-offer__university-name[data-v-b2de2106]{font-size:16px;color:#000;font-weight:700;margin:0 0 10px\n}\n.my-offer__meta[data-v-b2de2106]{display:inline-block\n}\n.my-offer__meta-list[data-v-b2de2106]{border-bottom:2px solid #0aa0d7;padding-bottom:8px\n}\n.my-offer__meta[data-v-b2de2106]:not(:first-child){margin-left:1em\n}\n.my-offer__links[data-v-b2de2106]{letter-spacing:4em\n}\n.my-offer__link[data-v-b2de2106]{display:inline-block;vertical-align:middle;margin-top:10px;letter-spacing:normal\n}\n.my-offer__missing-notice[data-v-b2de2106]{font-weight:700;color:red\n}\n.my-wrap[data-v-b2de2106]{display:inline-block\n}\n.gaibu-link[data-v-b2de2106]{text-decoration:underline\n}\n@media (max-width:709px){\n.my-offer__body[data-v-b2de2106],.my-offer__header-body[data-v-b2de2106]{padding-left:10px\n}\n.my-offer__body[data-v-b2de2106]{padding-right:10px\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PreferredUnivManager = __webpack_require__(150);

var _PreferredUnivManager2 = _interopRequireDefault(_PreferredUnivManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _fetchRequestId = 0;
exports.default = {
  name: 'dn-bible-myuniv-app',

  data: function data() {
    return {

      // debug
      debug: this.$route.query.debug !== undefined,

      useScore: !this.$store.getters['config/isManabi'],

      // constants
      displayItemDetailKeys: ['faculty_name', 'department_name', 'schedule_name', 'examination_method_name'],

      // states
      state: 'pending',
      fecthState: 'pending',
      downloadStatus: null,
      isAnimating: false,
      hashJumped: false,

      // values
      needFetch: true,
      hits: null,
      schoolChoices: [],
      missings: []
    };
  },


  computed: {

    // refs
    $downloader: function $downloader() {
      return this.$refs.downloader;
    },


    // flags
    hasData: function hasData() {
      return this.downloadStatus ? this.downloadStatus.hasData : false;
    },
    isEmpty: function isEmpty() {
      return this.hits ? this.offers.length === 0 : false;
    },
    isFetching: function isFetching() {
      return this.fecthState === 'fetching';
    },
    isFetched: function isFetched() {
      return this.fecthState === 'fetched';
    },
    hasFetchError: function hasFetchError() {
      return this.fecthState === 'error';
    },
    searchValues: function searchValues() {
      return { id: this.schoolChoices.map(function (id) {
          return id;
        }) };
    },
    kai: function kai() {
      return dn.$store.getters['config/kai'];
    },


    // values
    offers: function offers() {
      var _this = this;

      return this.schoolChoices.map(function (id, index) {
        var hit = _this.hits.hits.find(function (row) {
          return row.id === id;
        });
        if (!hit) _this.missings.push(id);
        // バージョンが最新でない場合改組
        if (hit && hit.version !== _this.kai) {
          hit["missing"] = true;
          _this.missings.push(id);
        }
        return Object.assign({
          university_id: id.slice(0, 4),
          isFirst: index === 0,
          isLast: index === _this.schoolChoices.length - 1
        }, hit ? hit : { id: id, missing: true });
      });
    },
    linkReady: function linkReady() {
      return this.$store.getters['links/loaded'];
    },
    C2IsReady: function C2IsReady() {
      return this.$store.getters['links/enabled']('C39') || this.$store.getters['config/isManabi'];
    }
  },

  methods: {

    /**
     * ダウンロードが完了してフォームがマウントされてからの初期化処理
     */
    init: function init() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.pushFetchQueue();

              case 2:

                _this2.state = 'ready';

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },


    /**
     * データをフェッチして変数に保持する
     */
    pushFetchQueue: function pushFetchQueue() {
      var _this3 = this;

      var condition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.searchValues;

      return new Promise(function (resolve, reject) {
        var myQueue = {
          resolved: false,
          rejected: false,
          running: false,
          done: false,
          hits: null,
          error: null
        };

        var myIndex = _this3.fetchQueues.length;

        myQueue.trigger = function () {
          myQueue.running = true;

          var onDone = function onDone(error) {
            myQueue.running = false;
            myQueue.done = true;

            var nextQueue = _this3.fetchQueues[myIndex + 1];

            if (error) {
              reject(error);
            } else {
              resolve();
            }

            return nextQueue ? nextQueue.trigger() : _this3.onFinishFetchQueues();
          };

          dn.db.searchOffers(condition).then(function (hits) {
            myQueue.resolved = true;
            myQueue.hits = hits;
            return onDone();
          }).catch(function (error) {
            myQueue.rejected = true;
            myQueue.done = true;
            myQueue.error = error;
            return onDone(error);
          });
        };

        var hasBefore = false;
        if (myIndex > 0) {
          for (var i = 0; i < myIndex; i++) {
            if (_this3.fetchQueues[i].running || !_this3.fetchQueues[i].done) {
              hasBefore = true;
              break;
            }
          }
        }

        _this3.fetchQueues.push(myQueue);

        if (!hasBefore) {
          _this3.onStartFetchQueues();
          myQueue.trigger();
        }
      });
    },


    /**
     * フェッチキューの実行が開始した時のコールバック
     */
    onStartFetchQueues: function onStartFetchQueues() {
      this.fecthState = 'fetching';
      dn.loading.show();
    },


    /**
     * フェッチキューの実行が全て完了した時のコールバック
     */
    onFinishFetchQueues: function onFinishFetchQueues() {
      dn.loading.hide();

      var hits = void 0;
      var errors = [];

      this.fetchQueues.forEach(function (queue) {
        if (queue.hits) hits = queue.hits;
        if (queue.error) errors.push(queue.error);
      });

      if (errors.length) {
        this.fecthState = 'error';
        throw new Error(errors);
      }

      if (hits) {
        this.missings = [];
        this.hits = hits;
      }

      this.needFetch = false;
      this.fecthState = 'fetched';
      this.tryFirstHashJumpToOffer();
    },


    /**
     * 初期フェッチ時のハッシュジャンプを試みる
     */
    tryFirstHashJumpToOffer: function tryFirstHashJumpToOffer() {
      if (this.hashJumped || !location.hash) {
        this.hashJumped = true;
        return;
      }

      this.hashJumped = true;
      var id = location.hash.replace(/^#my-offer-/, '');
      this.tryScrollToOffer(id);
    },


    /**
     * 指定のIDの志望校へのスクロールを試みる
     */
    tryScrollToOffer: function tryScrollToOffer(id) {
      var _this4 = this;

      this.$nextTick(function () {
        var $offers = _this4.$refs.offers && _this4.$refs.offers.length ? _this4.$refs.offers : null;
        if (!$offers) return;

        var $offer = $offers.find(function ($offer) {
          return $offer.id === 'my-offer-' + id;
        });

        if (!$offer) return;
        _this4.$scrollTo($offer, 250);
      });
    },


    /**
     * 登録志望校更新時のコールバック
     */
    onChangeSchoolChoices: function onChangeSchoolChoices() {
      var _this5 = this;

      var schoolChoices = dn.segments.schoolChoices.find();

      // すでにフェッチしているデータで足りていないかチェック
      var hasData = false;
      if (this.hits && this.hits.hits) {
        hasData = true;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          var _loop = function _loop() {
            var id = _step.value;

            if (!_this5.hits.hits.find(function (row) {
              return row.id === id;
            }) && !_this5.missings.includes(id)) {
              hasData = false;
              return 'break';
            }
          };

          for (var _iterator = schoolChoices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ret = _loop();

            if (_ret === 'break') break;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      if (!hasData) this.needFetch = true;

      this.$set(this, 'schoolChoices', schoolChoices);

      if (!hasData) this.pushFetchQueue();
    },


    /**
     * ダウンローダのデータの準備が出来た時のコールバック
     */
    onDataReady: function onDataReady() {
      this.init();
    },


    /**
     * データのダウンロードが発生した後のコールバック
     */
    onDownload: function onDownload() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this6.pushFetchQueue();

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },


    /**
     * 志望校DOMのアニメーションを伴う処理を行う時のメソッドラッパー
     * セグメントの監視を一回停止した上で非同期メソッドを行い
     * 完了したら元に戻す
     */
    animateOfferFunction: function animateOfferFunction(promise) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this7.isAnimating) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:

                _this7.isAnimating = true;
                _this7.stopWatchSchoolChoices();

                _context3.next = 6;
                return promise();

              case 6:

                _this7.isAnimating = false;
                _this7.startWatchSchoolChoices();
                _this7.onChangeSchoolChoices();

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },


    /**
     * 志望校を削除する
     */
    deleteOffer: function deleteOffer(e, offer) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return dn.$confirm('削除しても宜しいですか？');

              case 2:
                if (_context5.sent) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt('return', false);

              case 4:
                _context5.next = 6;
                return new Promise(function (resolve) {
                  setTimeout(resolve, 150);
                });

              case 6:
                _context5.next = 8;
                return _this8.animateOfferFunction(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                  var $offer;
                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          dn.segments.schoolChoices.remove(offer.id);

                          $offer = $(e.target).closest('.my-offer');

                          if (_this8.$store.getters['config/isManabi']) {
                            _this8.PreferredUnivManager.send();
                          }

                          _context4.next = 5;
                          return new Promise(function (resolve, reject) {
                            $offer.slideUp(350, resolve);
                          });

                        case 5:
                        case 'end':
                          return _context4.stop();
                      }
                    }
                  }, _callee4, _this8);
                })));

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },


    /**
     * 志望校の位置を移動する
     */
    moveOffer: function moveOffer(e, offer, vec) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this9.animateOfferFunction(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                  var $offer, isDown, $pair, offerHeight, pairHeight, duration, easing, transition, transform, resetStyles;
                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          dn.segments.schoolChoices.move(offer.id, vec);

                          $offer = $(e.target).closest('.my-offer'), isDown = vec === 'down', $pair = $offer[isDown ? 'next' : 'prev'](), offerHeight = $offer.outerHeight(), pairHeight = $pair.outerHeight(), duration = 350, easing = 'snap';


                          $offer.addClass('my-offer--moving');
                          $pair.addClass('my-offer--moving');

                          transition = duration + 'ms';
                          transform = {
                            offer: 'translateY(' + (isDown ? pairHeight : -pairHeight) + 'px)',
                            pair: 'translateY(' + (isDown ? -offerHeight : offerHeight) + 'px)'
                          };
                          resetStyles = {
                            'transform': '',
                            '-webkit-transform': '',
                            transition: ''
                          };


                          $offer.css({
                            'transform': transform.offer,
                            '-webkit-transform': transform.offer,
                            transition: transition
                          });
                          $pair.css({
                            'transform': transform.pair,
                            '-webkit-transform': transform.pair,
                            transition: transition
                          });

                          _context6.next = 11;
                          return new Promise(function (resolve) {
                            return setTimeout(resolve, duration);
                          });

                        case 11:
                          $offer.css(resetStyles).removeClass('my-offer--moving');
                          $pair.css(resetStyles).removeClass('my-offer--moving');

                        case 13:
                        case 'end':
                          return _context6.stop();
                      }
                    }
                  }, _callee6, _this9);
                })));

              case 2:
                if (_this9.$store.getters['config/isManabi']) {
                  _this9.PreferredUnivManager.send();
                }

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9);
      }))();
    },


    /**
     * セグメントの監視を開始する
     */
    startWatchSchoolChoices: function startWatchSchoolChoices() {
      var _this10 = this;

      dn.segments.schoolChoices.listen(function () {
        _this10.onChangeSchoolChoices();
      }, 'pg-bible-myuniv');
    },


    /**
     * セグメントの監視を停止する
     */
    stopWatchSchoolChoices: function stopWatchSchoolChoices() {
      dn.segments.schoolChoices.stopListen(undefined, 'pg-bible-myuniv');
    },


    /**
     * DBに志望校情報を保存
     */
    storeUnivList: function storeUnivList() {
      /* Cookie */
      var univList = dn.segments.schoolChoices.find();
      // let userType = dn.segments.userType.getId();
      if (!univList) {
        return;
      }

      fetch('', {
        method: 'POST',
        body: JSON.stringify(univList),
        headers: {
          'Content-Type': 'application/json'
        }
      }).catch(function (error) {
        // dn.$alert('エラーが発生したため志望大をDB連携できませんでした。');
      });
    }
  },

  created: function created() {
    var _this11 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _this11.fetchQueues = [];
              _this11.PreferredUnivManager = new _PreferredUnivManager2.default();

            case 2:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this11);
    }))();
  },
  mounted: function mounted() {
    var _this12 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return dn.segments.ready();

            case 2:
              _this12.startWatchSchoolChoices();

            case 3:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this12);
    }))();
  }
};

/***/ }),

/***/ 847:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pg-app"
    }
  }, [(_vm.$store.getters['config/isManabi']) ? [_c('dn-db-downloader', {
    ref: "downloader",
    staticClass: "mb20",
    attrs: {
      "target": "@offers"
    },
    on: {
      "data-ready": _vm.onDataReady,
      "download": _vm.onDownload
    },
    model: {
      value: (_vm.downloadStatus),
      callback: function($$v) {
        _vm.downloadStatus = $$v
      },
      expression: "downloadStatus"
    }
  }), _vm._v(" "), (_vm.hasData) ? _c('div', [(!_vm.needFetch) ? _c('div', [(_vm.isEmpty) ? _c('div', [_vm._m(0)]) : _c('div', [_c('p', {
    staticClass: "mb15"
  }, [_vm._v("※出願の際には、各大学の最新の入試情報を確認してください。")]), _vm._v(" "), (_vm.linkReady) ? _c('ul', {
    staticClass: "my-offers"
  }, _vm._l((_vm.offers), function(offer, index) {
    return _c('li', {
      key: offer.id,
      ref: "offers",
      refInFor: true,
      staticClass: "my-offer",
      attrs: {
        "id": ("my-offer-" + (offer.id))
      }
    }, [_c('div', {
      staticClass: "my-offer__header"
    }, [_c('div', {
      staticClass: "my-offer__header-body"
    }, [_c('span', {
      staticClass: "my-offer__header-rank"
    }, [_vm._v("第" + _vm._s(index + 1) + "志望")])]), _vm._v(" "), _c('a', {
      staticClass: "my-offer__header-action",
      class: {
        'is-disabled': offer.isFirst
      },
      attrs: {
        "title": "1つ上へ移動",
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moveOffer($event, offer, 'up')
        }
      }
    }, [_c('dn-icon', {
      class: {
        'is-disabled': offer.isFirst
      },
      attrs: {
        "icon": "tri-up"
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "my-offer__header-action",
      class: {
        'is-disabled': offer.isLast
      },
      attrs: {
        "title": "1つ下へ移動",
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moveOffer($event, offer, 'down')
        }
      }
    }, [_c('dn-icon', {
      class: {
        'is-disabled': offer.isLast
      },
      attrs: {
        "icon": "tri-down"
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "my-offer__header-action",
      attrs: {
        "title": "削除",
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteOffer($event, offer)
        }
      }
    }, [_c('dn-icon', {
      attrs: {
        "icon": "trash"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "my-offer__body"
    }, [(offer.missing && !offer.university_name) ? _c('div', [_vm._m(1, true)]) : _c('div', [_c('h3', {
      staticClass: "my-offer__university-name"
    }, [_vm._v(_vm._s(offer.university_name))]), _vm._v(" "), _c('div', {
      staticClass: "my-offer__meta-list"
    }, _vm._l((_vm.displayItemDetailKeys), function(key) {
      return (offer[key]) ? _c('p', {
        key: key,
        staticClass: "my-offer__meta"
      }, [_vm._v(_vm._s(offer[key]))]) : _vm._e()
    })), _vm._v(" "), (offer.missing) ? _c('div', {
      staticStyle: {
        "padding-top": "10px"
      }
    }, [_vm._m(2, true)]) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "my-offer__links"
    }, [_c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "anchor"
      }
    }), _vm._v(" "), _c('a', {
      directives: [{
        name: "linkset",
        rawName: "v-linkset",
        value: ('C36'),
        expression: "'C36'"
      }],
      attrs: {
        "href": "../../jikosaiten/hantei/index.html"
      }
    }, [_vm._v("判定" + _vm._s(_vm.$store.getters['config/isManabi'] ? 'を見る' : 'チェッカーで出願校を考える'))]), _vm._v(" "), _c('dn-icon', {
      attrs: {
        "icon": "inspiration"
      }
    })], 1), _vm._v(" "), _c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "link"
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "gaibu-link",
      attrs: {
        "href": ("https://manabi.benesse.ne.jp/daigaku/school/" + (offer.university_id) + "/nyushi/index.html"),
        "target": "_blank"
      }
    }, [_vm._v("最新の入試情報を見る")])], 1), _vm._v(" "), _c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "link"
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "gaibu-link",
      attrs: {
        "href": ("https://manabi.benesse.ne.jp/daigaku/school/" + (offer.university_id) + "/index.html"),
        "target": "_blank"
      }
    }, [_vm._v("パンフ・願書を取り寄せる")])], 1), _vm._v(" "), (!_vm.$store.getters['config/isManabi']) ? _c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "anchor"
      }
    }), _vm._v(" "), _c('a', {
      directives: [{
        name: "linkset",
        rawName: "v-linkset",
        value: ('C19'),
        expression: "'C19'"
      }],
      attrs: {
        "href": "../../refresh/i_sum.html",
        "target": "_blank"
      }
    }, [_vm._v("インターネット選太君で出願校を考える")]), _vm._v(" "), _c('dn-icon', {
      attrs: {
        "icon": "inspiration"
      }
    })], 1) : _vm._e()])])])])
  })) : _vm._e(), _vm._v(" "), (_vm.offers.length >= 1) ? _c('div', {
    staticClass: "my-to-checker tar mt30"
  }, [_c('dn-btn', {
    staticClass: "my-to-checker__btn",
    attrs: {
      "accent": "",
      "href": "../../jikosaiten/hantei/index.html",
      "linkset": "C36"
    }
  }, [_vm._v("\n            判定の確認" + _vm._s(_vm.$store.getters['config/isManabi'] ? '' : '　判定チェッカー') + "\n          ")])], 1) : _vm._e()])]) : _vm._e()]) : _vm._e()] : [_c('dn-db-downloader', {
    ref: "downloader",
    staticClass: "mb20",
    attrs: {
      "target": "@offers"
    },
    on: {
      "data-ready": _vm.onDataReady,
      "download": _vm.onDownload
    },
    model: {
      value: (_vm.downloadStatus),
      callback: function($$v) {
        _vm.downloadStatus = $$v
      },
      expression: "downloadStatus"
    }
  }), _vm._v(" "), (_vm.hasData) ? _c('div', [(!_vm.needFetch) ? _c('div', [(_vm.isEmpty) ? _c('div', [_vm._m(3)]) : _c('div', [_c('p', {
    staticClass: "mb15"
  }, [_vm._v("※出願の際には、各大学の最新の入試情報を確認してください。")]), _vm._v(" "), (_vm.linkReady) ? _c('ul', {
    staticClass: "my-offers"
  }, _vm._l((_vm.offers), function(offer, index) {
    return _c('li', {
      key: offer.id,
      ref: "offers",
      refInFor: true,
      staticClass: "my-offer",
      attrs: {
        "id": ("my-offer-" + (offer.id))
      }
    }, [_c('div', {
      staticClass: "my-offer__header"
    }, [_c('div', {
      staticClass: "my-offer__header-body"
    }, [_c('span', {
      staticClass: "my-offer__header-rank"
    }, [_vm._v("第" + _vm._s(index + 1) + "志望")])]), _vm._v(" "), _c('a', {
      staticClass: "my-offer__header-action",
      class: {
        'is-disabled': offer.isFirst
      },
      attrs: {
        "title": "1つ上へ移動",
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moveOffer($event, offer, 'up')
        }
      }
    }, [_c('dn-icon', {
      class: {
        'is-disabled': offer.isFirst
      },
      attrs: {
        "icon": "tri-up"
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "my-offer__header-action",
      class: {
        'is-disabled': offer.isLast
      },
      attrs: {
        "title": "1つ下へ移動",
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.moveOffer($event, offer, 'down')
        }
      }
    }, [_c('dn-icon', {
      class: {
        'is-disabled': offer.isLast
      },
      attrs: {
        "icon": "tri-down"
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "my-offer__header-action",
      attrs: {
        "title": "削除",
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteOffer($event, offer)
        }
      }
    }, [_c('dn-icon', {
      attrs: {
        "icon": "trash"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "my-offer__body"
    }, [(offer.missing && !offer.university_name) ? _c('div', [_vm._m(4, true)]) : _c('div', [_c('h3', {
      staticClass: "my-offer__university-name"
    }, [_vm._v(_vm._s(offer.university_name))]), _vm._v(" "), _c('div', {
      staticClass: "my-offer__meta-list"
    }, _vm._l((_vm.displayItemDetailKeys), function(key) {
      return (offer[key]) ? _c('p', {
        key: key,
        staticClass: "my-offer__meta"
      }, [_vm._v(_vm._s(offer[key]))]) : _vm._e()
    })), _vm._v(" "), (offer.missing) ? _c('div', {
      staticStyle: {
        "padding-top": "10px"
      }
    }, [_vm._m(5, true)]) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "my-offer__links"
    }, [_c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "anchor"
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": ("https://manabi.benesse.ne.jp/daigaku/school/" + (offer.university_id) + "/index.html"),
        "target": "_blank"
      }
    }, [_vm._v("パンフ・願書を取り寄せる")])], 1), _vm._v(" "), _c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "anchor"
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": ("https://manabi.benesse.ne.jp/daigaku/school/" + (offer.university_id) + "/nyushi/index.html"),
        "target": "_blank"
      }
    }, [_vm._v("最新の入試情報を見る")])], 1), _vm._v(" "), _c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "anchor"
      }
    }), _vm._v(" "), _c('a', {
      directives: [{
        name: "linkset",
        rawName: "v-linkset",
        value: ('B3'),
        expression: "'B3'"
      }],
      attrs: {
        "href": "../../bible/exam/index.html"
      }
    }, [_vm._v("過去の共通テスト・センター試験を解いて強化する科目・分野を把握する")]), _vm._v(" "), _c('dn-icon', {
      attrs: {
        "icon": "inspiration"
      }
    })], 1), _vm._v(" "), _c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "anchor"
      }
    }), _vm._v(" "), _c('a', {
      directives: [{
        name: "linkset",
        rawName: "v-linkset",
        value: ('C36'),
        expression: "'C36'"
      }],
      attrs: {
        "href": ("../../jikosaiten/hantei/index.html?offer=" + (index + 1)),
        "target": "_blank"
      }
    }, [_vm._v("判定" + _vm._s(_vm.$store.getters['config/isManabi'] ? 'を見て' : 'チェッカーで') + "出願校を考える")]), _vm._v(" "), _c('dn-icon', {
      attrs: {
        "icon": "inspiration"
      }
    })], 1), _vm._v(" "), (!_vm.$store.getters['config/isManabi']) ? _c('li', {
      staticClass: "my-offer__link"
    }, [_c('dn-icon', {
      attrs: {
        "icon": "anchor"
      }
    }), _vm._v(" "), _c('a', {
      directives: [{
        name: "linkset",
        rawName: "v-linkset",
        value: ('C19'),
        expression: "'C19'"
      }],
      attrs: {
        "href": "../../refresh/i_sum.html",
        "target": "_blank"
      }
    }, [_vm._v("インターネット選太君で出願校を考える")]), _vm._v(" "), _c('dn-icon', {
      attrs: {
        "icon": "inspiration"
      }
    })], 1) : _vm._e()])])])])
  })) : _vm._e(), _vm._v(" "), (_vm.offers.length >= 3) ? _c('div', {
    staticClass: "tar mt30"
  }, [(_vm.$store.getters['config/isManabi']) ? _c("dn-btn", {
    tag: "a",
    staticClass: "pg-linkto-search dn-btn--plain dn-btn--block-sp",
    on: {
      "click": function($event) {
        _vm.storeUnivList()
      }
    }
  }, [_vm._v("DB連携")]) : _vm._e(), _vm._v(" "), _c("dn-btn", {
    tag: "a",
    staticClass: "pg-linkto-search dn-btn--plain dn-btn--block-sp",
    attrs: {
      "linkset": "B6",
      "href": "../search/index.html"
    }
  }, [_vm._v("大学検索")])]) : _vm._e()])]) : _vm._e()]) : _vm._e()]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-bottom": "120px"
    }
  }, [_vm._v("現在登録はありません。「"), _c('a', {
    attrs: {
      "href": "../search/index.html"
    }
  }, [_vm._v("志望校を検索・登録する")]), _vm._v("」からご登録ください。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "my-offer__missing-notice"
  }, [_vm._v("募集単位に改組がありました。"), _c('wbr'), _vm._v("選択し直してください。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "my-offer__missing-notice"
  }, [_vm._v("大学入学共通テストを利用しない募集単位のため、判定できません。志望校の登録を再度ご確認ください。"), _c('br'), _vm._v("（国公立大学以外で大学入学共通テストを利用する場合は募集単位名に「共テ」がついています）")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-bottom": "120px"
    }
  }, [_vm._v("現在登録はありません。「"), _c('a', {
    attrs: {
      "href": "../search/index.html"
    }
  }, [_vm._v("志望大学を検索・登録する")]), _vm._v("」からご登録ください。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "my-offer__missing-notice"
  }, [_vm._v("募集単位に改組がありました。"), _c('wbr'), _vm._v("選択し直してください。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "my-offer__missing-notice"
  }, [_vm._v("大学入学共通テストを利用しない募集単位のため、判定できません。志望校の登録を再度ご確認ください。"), _c('br'), _vm._v("（国公立大学以外で大学入学共通テストを利用する場合は募集単位名に「共テ」がついています）")])
}]}

/***/ })

/******/ });


// WEBPACK FOOTER //
// bible/myuniv/js/page.js